/**
 * Platform detection rather than feature detection, because what is being
 * offered is a native app that exists only for iOS and Android — there is no
 * capability to probe for.
 */

export type MobilePlatform = 'ios' | 'android';

const ANDROID_UA_REGEX = /android/i;
const IOS_UA_REGEX = /iPad|iPhone|iPod/;

/** Tablets count as mobile: the TeamHub app ships for iPad and Android tablets too. */
export function detectMobilePlatform(): MobilePlatform | null {
  if (typeof navigator === 'undefined') {
    return null;
  }

  const userAgent = navigator.userAgent ?? '';

  if (ANDROID_UA_REGEX.test(userAgent)) {
    return 'android';
  }

  if (IOS_UA_REGEX.test(userAgent)) {
    return 'ios';
  }

  // An iPad sends a desktop Mac user agent; touch points are what separate it
  // from an actual Mac.
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return 'ios';
  }

  return null;
}
